"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.implementTypedPlatformFunction = void 0;
function implementTypedPlatformFunction(functionDef, implementation) {
    return {
        [functionDef.name]: (context, params) => {
            const request = functionDef.requestSchema.parse(params);
            const response = implementation(context, request);
            return functionDef.responseSchema.parse(response);
        },
    };
}
exports.implementTypedPlatformFunction = implementTypedPlatformFunction;
